import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, PlaySquareIcon, UserRoundIcon, TicketIcon, UsersIcon, HeartIcon } from 'lucide-react';
const benefits = [{
  icon: <BarChart3Icon className="w-5 h-5 text-brand-cyan" data-id="element-19" />,
  title: 'Live Match Stats',
  description: 'Real-time scores, possession, shots, and advanced analytics updated instantly.'
}, {
  icon: <PlaySquareIcon className="w-5 h-5 text-brand-cyan" data-id="element-20" />,
  title: 'Instant Highlights',
  description: 'Missed a goal? Tap to watch key moments and multi-angle replays on your phone.'
}, {
  icon: <UserRoundIcon className="w-5 h-5 text-brand-cyan" data-id="element-21" />,
  title: 'Player Profiles',
  description: 'Deep dive into full bios, career stats, and current tournament form data.'
}, {
  icon: <TicketIcon className="w-5 h-5 text-brand-cyan" data-id="element-22" />,
  title: 'Real Time Info',
  description: 'Find everything you need — buy tickets, team news, schedules, and live updates all in one tap.'
}, {
  icon: <UsersIcon className="w-5 h-5 text-brand-cyan" data-id="element-23" />,
  title: 'Community',
  description: 'Celebrate victories together. Connect with fans, join groups, and share the passion worldwide.'
}, {
  icon: <HeartIcon className="w-5 h-5 text-brand-cyan" data-id="element-24" />,
  title: 'Pure Magic',
  description: "Your favorite team, one tap away. Feel the chills. This isn't just a t-shirt — it's the closest you'll ever be to the game you love."
}];
export function BenefitsSection() {
  return <section id="benefits" className="py-10 md:py-20 bg-brand-darkest relative" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-27">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 block" data-id="element-28">
            World Cup Experience
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold mb-3 md:mb-4" data-id="element-29">
            Everything at Your Fingertips.
          </h2>
          <p className="text-gray-400 text-sm md:text-lg" data-id="element-30">
            Tap your smart t-shirt and unlock the full World Cup 2026 experience
            — live data, highlights, community, and more.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-id="element-31">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="glass-card p-4 md:p-6 group hover:bg-white/10 transition-colors border-brand-cyan/10 hover:border-brand-cyan/30" data-id="element-32">
              <div className="w-9 h-9 md:w-11 md:h-11 rounded-lg md:rounded-xl bg-brand-cyan/10 flex items-center justify-center mb-3 md:mb-4 group-hover:scale-110 transition-transform" data-id="element-33">
                {benefit.icon}
              </div>
              <h3 className="text-sm md:text-lg font-bold mb-1 md:mb-2 font-heading" data-id="element-34">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-[11px] md:text-sm" data-id="element-35">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}